import { Routes } from "@angular/router";

export const custompage: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("../../component/custom-pages/custom-pages.module").then(
        (m) => m.CustomPagesModule
      ),
  },
];
